import {IState} from 'angular-ui-router';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';

testpageRun.$inject = ['RouterHelper'];

/* @ngInject */
export function testpageRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            name: 'testpage',
            template: '<dv-testpage-view flex="auto" class="overflow-scroll"></dv-testpage-view>',
            url: '/testpage',
        },

    ];
}






// WEBPACK FOOTER //
// ./src/app/testpage/testpage.route.ts